import React, { useEffect } from 'react';
import "../../App.css";
import { useNavigate } from 'react-router-dom';
import EconoJournalLogo from "../../components/EconoJournalLogo";

export default function PagoPending() {
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.clear();
  }, []);

  const btnBackToHome = () => {
    navigate('/');
  };

  return (
    <div className='thanks'>
      <EconoJournalLogo className="logoECJ" />
      <h2>Estamos procesando tu pago</h2>
      <h4>Tu pago está pendiente. Te avisaremos por mail cuando se apruebe.</h4>
      <button onClick={btnBackToHome}>Volver al inicio</button>
    </div>
  );
}
